import React from 'react';
import {
    Switch,
    Route
} from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './containers/home';
import News from './containers/news';
import Alliance from './containers/alliance';
import Plan from './containers/plan';
import Classroom from './containers/classroom';
import ClassroomMore from './containers/classroomMore';
import PageInfo from './containers/pageInfo';
import './app.scss';
import helperImg from './asset/img/head.png';

const updateMetaTags = (meta) => {
    // 直接更新title（已验证有效）
    document.title = meta.title;

    // 更保守的meta更新策略
    const updateMeta = (name, content) => {
        const meta = document.querySelector(`meta[name="${name}"]`);
        if (meta) {
            // 仅更新content属性
            meta.setAttribute('content', content);
        } else {
            // 如果不存在则创建
            const newMeta = document.createElement('meta');
            newMeta.name = name;
            newMeta.content = content;
            document.head.appendChild(newMeta);
        }
    };

    // 立即尝试更新
    updateMeta('description', meta.description);
    updateMeta('keywords', meta.keywords);

    // 确保在React渲染周期后再次检查
    setTimeout(() => {
        updateMeta('description', meta.description);
        updateMeta('keywords', meta.keywords);
    }, 100);
};

const routeMeta = {
    '/': {
        title: '百度安全反欺诈中心',
        description: '由国家电信诈骗重点实验室和中国互联网协会反诈骗中心主办，百度安全反欺诈中心旨在普及反诈知识，提供实用防骗技巧，以及最新诈骗案例分析。',
        keywords: '百度安全,反欺诈,反诈骗,防骗技巧,诈骗案例,网络安全'
    },
    '/news': {
        title: '新闻资讯',
        description: '百度安全反欺诈中心新闻资讯栏目，为您提供最新的反诈骗政策动态、案件通报和防范知识更新。',
        keywords: '反诈骗新闻,政策动态,案件通报,防范知识,百度安全资讯'
    },
    '/alliance': {
        title: '合作伙伴',
        description: '百度安全反欺诈中心合作伙伴介绍，我们与多家权威机构和企业携手共建反诈骗防线。',
        keywords: '合作伙伴,反欺诈联盟,权威机构,企业合作,共建防线'
    },
    '/plan': {
        title: '反诈解决方案',
        description: '百度安全反欺诈解决方案，提供全方位的反诈骗技术服务和防范策略，助力企业防范电信网络诈骗。',
        keywords: '反诈解决方案,技术服务,防范策略,企业防骗,安全防护'
    },
    '/classroom': {
        title: '防骗小课堂',
        description: '防骗小课堂，通过生动案例和实用技巧，帮助您识别和防范各类诈骗手段。',
        keywords: '防骗课堂,诈骗案例,实用技巧,识别诈骗,安全教育'
    },
    '/classroomMore': {
        title: '更多课程',
        description: '更多防骗课程学习，深入了解各类诈骗手法和防范措施，提高安全意识。',
        keywords: '防骗课程,诈骗手法,防范措施,安全意识,深度学习'
    },
    '/page/:type/:id': {
        title: '详情',
        description: '百度安全反欺诈中心详情页面',
        keywords: '详情页面,文章详情,内容详情'
    }
};

class App extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            conMinHeight: 0
        };
    }

    componentDidMount() {
        this.setState({
            conMinHeight: window.innerHeight - this.footer.offsetHeight
        });
    }

    render() {
        return (
            <div className="App">
                <Nav/>
                <div style={{minHeight: `${this.state.conMinHeight}px`}}>
                    <Switch>
                        <Route exact path={'/'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <Home {...props} />;
                        }}/>
                        <Route exact path={'/news'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <News {...props} />;
                        }}/>
                        <Route exact path={'/alliance'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <Alliance {...props} />;
                        }}/>
                        <Route exact path={'/plan'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <Plan {...props} />;
                        }}/>
                        <Route exact path={'/classroom'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <Classroom {...props} />;
                        }}/>
                        <Route exact path={'/classroomMore'} render={(props) => {
                            const meta = routeMeta[props.match.path] || routeMeta['/'];
                            updateMetaTags(meta);
                            return <ClassroomMore {...props} />;
                        }}/>
                        <Route exact path={'/page/:type/:id'} render={(props) => {
                            const meta = routeMeta['/page/:type/:id'] || routeMeta['/'];
                            // 对于详情页面，使用默认的meta tags，具体内容由PageInfo组件动态更新
                            updateMetaTags(meta);
                            return <PageInfo {...props} />;
                        }}/>
                    </Switch>
                </div>
                <a
                href="https://mbd.baidu.com/ma/s/kUVZc12b"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    right: '20px',
                    bottom: '20px',
                    zIndex: 2000,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    cursor: 'pointer',
                    backgroundColor: 'rgba(0, 123, 255, 0.9)', // 蓝色背景
                    borderRadius: '12px',
                    padding: '10px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    transition: 'all 0.3s ease',
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.4)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
                }}
                >
                {/* 圆形图片 */}
                <img
                    src={helperImg}
                    alt="反诈助手"
                    style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginBottom: '6px',
                    border: '2px solid #fff', // 白色边框增加质感
                    }}
                />
                {/* 文字 */}
                <span
                    style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#fff',
                    textAlign: 'center',
                    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                    }}
                >
                    反诈助手
                </span>
                </a>




                <div ref={el => this.footer = el}>
                    <Footer/>
                </div>
            </div>
        );
    }

}

export default App;
